const initialState = {
  main: false
};

export default function (state = initialState, action) {
  // on error we stop all loaders
  if (action.error) {
    return {};
  }
  switch (action.type) {
    // global loader
    case 'START_LOADER':
      return {
        ...state,
        main: true
      };
    case 'STOP_LOADER':
      return {
        ...state,
        main: false
      };
  }
  // this code will auto create props based on type for loading i.e.:
  // FETCHING_SOME_DATA => someData: true
  // FETCHED_SOME_DATA => someData: false

  const matchFetching = action.type.match(/FETCHING_(.*)/) || action.type.match(/SUBMITTING_(.*)/) || action.type.match(/POSTING_(.*)/);
  if (matchFetching) {
    return {
      ...state,
      [toCamelCase(matchFetching[1])]: true
    };
  }

  const matchFetched = action.type.match(/FETCHED_(.*)/) || action.type.match(/SUBMITTED_(.*)/) || action.type.match(/POSTED_(.*)/);
  if (matchFetched) {
    return {
      ...state,
      [toCamelCase(matchFetched[1])]: false
    };
  }
  return state;
}

function toCamelCase(word) {
  return word.toLowerCase().replace(/_./g, match => match[1].toUpperCase());
}



// WEBPACK FOOTER //
// ./src/app/state/reducers/loaders.reducer.js